import React from "react";

const HeaderLine = ({ text, isMT, isMB }) => {
  return (
    <div
      className={`flexStart heading-with-gray-line ${isMT ? "mt30" : ""} ${
        isMB ? "mb30" : ""
      }`}
    >
      <h2 className="page-heading">{text || ""}</h2>
      <div className="grayLine"></div>
    </div>
  );
};

export default HeaderLine;
